export function clampPercent(value: number): number {
  return Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0))
}

export function formatPercent(value: number, digits = 0): string {
  return `${clampPercent(value).toFixed(digits)}%`
}

export function formatBytes(value: number, perSecond = false): string {
  if (!Number.isFinite(value) || value < 0) return '—'
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  let amount = value
  let index = 0
  while (amount >= 1000 && index < units.length - 1) {
    amount /= 1000
    index += 1
  }
  const precision = amount >= 100 || index === 0 ? 0 : amount >= 10 ? 1 : 2
  return `${amount.toFixed(precision)} ${units[index]}${perSecond ? '/s' : ''}`
}

export function formatDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0))
  const days = Math.floor(seconds / 86_400)
  const hours = Math.floor((seconds % 86_400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if (days)
    return `${i18n.global.t('time.day', { count: days })} ${i18n.global.t('time.hour', { count: hours })}`
  if (hours)
    return `${i18n.global.t('time.hour', { count: hours })} ${i18n.global.t('time.minute', { count: minutes })}`
  if (minutes) return i18n.global.t('time.minute', { count: minutes })
  return i18n.global.t('time.second', { count: seconds })
}

export function formatRelativeTime(value: string | null): string {
  if (!value) return i18n.global.t('time.never')
  const timestamp = Date.parse(value)
  if (!Number.isFinite(timestamp)) return i18n.global.t('time.unknown')
  const seconds = Math.round((timestamp - Date.now()) / 1000)
  const formatter = new Intl.RelativeTimeFormat(i18n.global.locale.value, { numeric: 'auto' })
  if (Math.abs(seconds) < 60) return formatter.format(seconds, 'second')
  const minutes = Math.round(seconds / 60)
  if (Math.abs(minutes) < 60) return formatter.format(minutes, 'minute')
  const hours = Math.round(minutes / 60)
  if (Math.abs(hours) < 24) return formatter.format(hours, 'hour')
  return formatter.format(Math.round(hours / 24), 'day')
}

export function formatClock(value: Date | null): string {
  return value
    ? value.toLocaleTimeString(i18n.global.locale.value, { hour: '2-digit', minute: '2-digit' })
    : i18n.global.t('common.notAvailable')
}
import { i18n } from '@/i18n'
